import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
import { CustomErrorsHandlerService } from 'src/app/_services/custom-errors-handler.service';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
@Component({
  selector: 'app-short-key',
  templateUrl: './short-key.component.html',
  styleUrls: ['./short-key.component.css']
})
export class ShortKeyComponent implements OnInit {
  urlParam: string;
  surveyURL : string;
  showLoader:boolean = true;
  productName : string = "sogo";
  constructor(public service: ParticipationDataService,
    private router: Router, 
    private activatedRoute: ActivatedRoute,
    private errorsHandlerService: CustomErrorsHandlerService,
    private titleService: Title) { }


  ngOnInit(): void {
    let URlData = this.GetUrlData();
    let strDecodeUrl ="ShortKey?"+URlData;
      this.service.GetDataProp(strDecodeUrl).subscribe(async (data)=>{
        var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
        this.surveyURL = await JSON.parse(arrData);  
        if(this.surveyURL)
        {
          window.location.replace(this.surveyURL);
        }
        else
        { 
        const formatListShowDay = document.querySelector('.message-wrapper') as HTMLElement;  
          formatListShowDay.style.display = 'block';
        }
      }, error => {
            this.errorsHandlerService.handleError(error);
            if(error.name =="HttpErrorResponse")
            {
                window.location.replace("..survey/sd?err=1&ng=2&cn=0");
            }
      });

  }

  GetUrlData(): any {
    this.activatedRoute.queryParams.subscribe(async params => {
      let k = (params['k'] == "" || params['k'] == undefined) ? "" : params['k'];
      this.urlParam = 'k=' + k ; 
    });
    return this.urlParam;
  }
}
